module.exports = "/_next/static/images/AppStore-66b16aac9697220ff66e6a13f0bbce4b.svg";